module.exports = __webpack_public_path__ + "static/media/calibration_setp1_correct.ff48bff3.png";